"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _ButtonText = _interopRequireDefault(require("@commerce-ui/core2/ButtonText"));
var _core = require("@commerce-ui/core2");
var _ButtonMinimalIcon = _interopRequireDefault(require("../ButtonMinimalIcon"));
var __jsx = _react["default"].createElement;
// const heights = {
//   small: "36px",
//   standard: "48px",
//   large: "58px"
// };

var fonts = {
  small: "body2",
  standard: "base_sans",
  large: "base_sans",
  upper: "xs_caps"
};
var _default = (0, _core.createComponent)(_ButtonText["default"], function (_ref) {
  var _ref$$size = _ref.$size,
    $size = _ref$$size === void 0 ? "standard" : _ref$$size,
    _ref$$color = _ref.$color,
    $color = _ref$$color === void 0 ? "main" : _ref$$color,
    _ref$$smallIcon = _ref.$smallIcon,
    $smallIcon = _ref$$smallIcon === void 0 ? false : _ref$$smallIcon;
  return {
    // height: heights[$size],
    ":focus": {
      outline: 0,
      boxShadow: "none"
    },
    "::-moz-focus-inner": {
      border: 0
    },
    svg: {
      display: "block"
    },
    lineHeight: 1,
    $body: function $body(_ref2) {
      var isHovered = _ref2.isHovered;
      return {
        color: $color,
        font: fonts[$size],
        opacity: isHovered ? 0.8 : 1,
        lineHeight: 1
      };
    },
    $gap: $smallIcon ? "10px" : "4px",
    $iconSize: $smallIcon ? 16 : 24,
    $loader: {
      __children: __jsx(_ButtonMinimalIcon["default"], {
        sx: {
          $color: $color,
          $color2: "rgba(255,255,255,0.2)"
        }
      })
    }
  };
});
exports["default"] = _default;